import { Component } from '@angular/core';
import { AuthFlowStatus, CognitoService } from '../../services/cognito.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-new-password-require',
  imports: [CommonModule, FormsModule],
  templateUrl: './new-password-require.component.html',
  styleUrl: './new-password-require.component.scss'
})
export class NewPasswordRequireComponent {

  currentpassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  showConfirmPassword: any;
  showNewPassword: any;
  passwordRequirementsVisible: boolean = false;
  secondPasswordTyped: boolean = false;
  passwordError: boolean = false;
  validateError: boolean = false;
  successModal: boolean = false;
  loading: boolean = false;
  unMatchPassword: boolean = false;
  errorMessage: string = '¡Error! no se pudo cambiar la contraseña.';

  constructor(
    private authService: CognitoService, 
    private router: Router
  ) {}

  ngOnInit(): void {
    if (!this.authService.hasPendingNewPasswordChallenge()) {
      this.router.navigate(["/login"]);
    }
  }

  passwordsMatch(): boolean {
    return this.newPassword === this.confirmPassword;
  }

  redirectToLoginPage(): void {
    this.router.navigate(["/login"]);
    this.successModal = false;
  }

  togglePasswordRequirements() {
    this.passwordRequirementsVisible = !this.passwordRequirementsVisible;
  }


  checkInputs() {
    if (!this.newPassword || !this.confirmPassword) {
        this.secondPasswordTyped = false;
    } else {
        this.secondPasswordTyped = true;
    }
}

  validatePassword(password: string): boolean {
    if (password.length < 8) {
      return false;
    }

    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
    const numericRegex = /[0-9]/;
    
    if (!lowercaseRegex.test(password) || !uppercaseRegex.test(password) || !specialCharRegex.test(password) || !numericRegex.test(password)) {
      this.passwordError = true;
      return false;
    }
    this.passwordError = false;
    return true;
  }

  async confirmPasswordReset() {
    if (this.loading) {
      return;
    }

    this.unMatchPassword = !this.passwordsMatch(); 
    if (this.unMatchPassword) {
      this.passwordError = false; 
      return; 
    }
    if (!this.validatePassword(this.newPassword)) {
      this.passwordError = true; 
      return; 
    }

    this.loading = true;
    this.validateError = false;

    try {
      const result = await this.authService.changePassword(this.currentpassword, this.newPassword, this.confirmPassword);

      switch (result.status) {
        case AuthFlowStatus.Authenticated:
        case AuthFlowStatus.EmailOtpRequired:
          this.newPassword = '';
          this.confirmPassword = '';
          break;
        case AuthFlowStatus.UnsupportedChallenge:
        case AuthFlowStatus.Error:
        default:
          this.errorMessage = result.message ?? '¡Error! no se pudo cambiar la contraseña.';
          this.validateError = true;
          break;
      }
    } finally {
      this.loading = false;
    }
  }

}
